export default state => {
	console.info('🦑 SET_EDIT_CLAIM_SUCCESS');
	state.editClaimSuccess = true;
};
